import type { SettingsResponse } from "@/app/providers/auth-provider/api";

export type IUserInfo = {
  id: number;
  email: string;
  roles: UserRolesValues[];
};

export type FullUser = {
  success: boolean;
  body?: {
    profile: {
      id: number;
      userId: number;
      firstName: string;
      lastName: string;
      picture: string;
      contacts: {
        id: number;
        userId: number;
        name: string;
        value: string;
      }[];
      postbackLinkIds: never[];
      timeZone: string;
    };
    rights?: {
      id: number;
      name: string;
    }[];
    refInfo: {
      wasInvited: boolean;
    };
    role: {
      id: number;
      name: string;
    };
    id: number;
    mail: string;
  };
  errorCode: number;
};

export type IUserJWT = {
  id: number;
  email: string;
  realm_access: { roles: UserRolesValues[] };
};

export type IUserStore = {
  user: FullUser | null;
  token: string | null;
  roles: string[];
  devSettings: SettingsResponse | null;

  fetchDevSettings: (signal?: AbortSignal) => Promise<SettingsResponse | null>;
  updateDevSettings: (settings: SettingsResponse | null) => void;
  setUser: (user: FullUser | null) => void;
  setToken: (token: string) => void;
  authorize: (token: string | null) => Promise<void>;
  devAuthorize: (token: string | null) => void;
};

export const USER_ROLES = {
  BillboardMonitoringWriteSuper: "BillboardMonitoringWriteSuper",
  BillboardMonitoringReadSuper: "BillboardMonitoringReadSuper",
  BillboardManagerReadSuper: "BillboardManagerReadSuper",
  BillboardManagerReadAdmin: "BillboardManagerReadAdmin",
  BillboardManagerCreateSuper: "BillboardManagerCreateSuper",
} as const;

export type UserRolesValues = (typeof USER_ROLES)[keyof typeof USER_ROLES];
